/**
 * Add-in entry point.
 *
 * Vite bundles this file starting from the <script type="module"> tag in
 * index.html.  We await window.__officeReady (a Promise set by the synchronous
 * bootstrap script) before mounting React, so Office.onReady is always
 * satisfied before the component tree renders.
 */

import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

async function mountApp() {
  // Block until the inline bootstrap resolves Office.onReady.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  await (window as any).__officeReady;

  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');

  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// Log runtime errors to console — do not wipe the React tree (would cause a
// follow-on DOM NotFoundError in Word's WebKit host).
window.addEventListener('error', (event) => {
  console.error('Add-in error:', event.error ?? event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  console.error('Add-in error:', event.reason);
});

mountApp().catch((err) => {
  console.error('Add-in failed to mount:', err);
});
